import { render, staticRenderFns } from "./GradeManageOld.vue?vue&type=template&id=85f4884c&scoped=true"
import script from "./GradeManageOld.vue?vue&type=script&lang=js"
export * from "./GradeManageOld.vue?vue&type=script&lang=js"
import style0 from "./GradeManageOld.vue?vue&type=style&index=0&id=85f4884c&prod&lang=scss"
import style1 from "./GradeManageOld.vue?vue&type=style&index=1&id=85f4884c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f4884c",
  null
  
)

export default component.exports